import { Auth } from 'aws-amplify'
import { useAlert } from 'react-alert'

import { useForm } from '../../hooks'
import { Button, InputPassword } from '../../components'
import { HeaderLinks, TitleCard } from './components'

import { IconSaveSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

const ChangePassword = () => {
  const oldPassword = useForm('oldPassword')
  const password = useForm('password')
  const confirmPassword = useForm('confirmPassword')
  const alert = useAlert()

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      const response = await Auth.currentAuthenticatedUser()

      await Auth.changePassword(response, oldPassword.value, password.value)
      alert.show('Senha alterada com sucesso', {
        type: 'success',
        timeout: 4000
      })
    } catch (error) {
      console.error(error)
      alert.show('Senha antiga e/ou senha nova inválidas, tente novamente', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  return (
    <S.Wrapper>
      <S.Title>Alterar senha</S.Title>
      <S.CardContainer>
        <form onSubmit={onSubmit}>
          <HeaderLinks
            routes={['/meus-dados', '/alterar-senha', '/meu-faturamento']}
          />

          <TitleCard title="Alterar senha" />

          <S.InputContainer>
            <InputPassword
              labelColor="#4F4F4F"
              label="Senha antiga"
              name="oldPassword"
              {...oldPassword}
            />
            <InputPassword
              labelColor="#4F4F4F"
              label="Senha nova"
              name="password"
              {...password}
            />
            <InputPassword
              labelColor="#4F4F4F"
              label="Confirmar senha"
              name="password"
              {...confirmPassword}
              error={
                confirmPassword.value &&
                password.value &&
                confirmPassword.value !== password.value
                  ? 'As senhas não são iguais'
                  : ''
              }
            />
          </S.InputContainer>
          <S.NewPasswordButtonContainer>
            <Button
              initialIcon={<IconSaveSvg />}
              hasblueButton
              className="button-save-password"
            >
              Salvar nova senha
            </Button>
          </S.NewPasswordButtonContainer>
        </form>
      </S.CardContainer>
    </S.Wrapper>
  )
}

export default ChangePassword
